import styled from "@emotion/styled";
import React from "react";

const StyledToggle = styled.button`
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 48px;
    width: 48px;
    border-radius: 12px;
    transform: translateX(8px);
    transition: all 0.2s;

    span,
    &::before,
    &::after {
      content: "";
      height: 2px;
      width: 24px;
      background: var(--sub);
      transition: all 0.2s ease-out;
    }
    &::before {
      margin-bottom: 6px;
    }
    &::after {
      margin-top: 6px;
    }
    &.open {
      &::before,
      &::after {
        background: var(--important);
      }
      span {
        opacity: 0;
      }
      &:before {
        transform: rotate(-135deg);
        margin-bottom: -10px;
      }
      &::after {
        transform: rotate(135deg);
      }
    }
  }
`;

export const Toggle = ({ isOpen, onClick, className: classNames }) => (
  <StyledToggle onClick={onClick} className={classNames}>
    <div className={isOpen ? "open" : ""}>
      <span />
    </div>
  </StyledToggle>
);
